import { Building2, Ruler, HardHat, Truck, CheckCircle, Clock, Award, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { lazy, Suspense } from 'react'
import SEO from '../components/SEO'

// ✅ Import images to ensure they work in production
import hero1 from '../assets/Services/construction/hero-1.jpg'
import hero2 from '../assets/Services/construction/hero-2.jpg'
import hero3 from '../assets/Services/construction/hero-3.jpg'
import turnkeyImg from '../assets/Services/construction/turnkey.jpg'
import equipmentImg from '../assets/Services/construction/equipment.jpg'
import contractingImg from '../assets/Services/construction/contracting.jpg'
import designImg from '../assets/Services/construction/design.jpg'
import siteImg from '../assets/Services/construction/site-development.jpg'
import renovationImg from '../assets/Services/construction/renovation.jpg'

const ServicePageLayout = lazy(() => import('../components/ServicePageLayout'))

const Construction = () => {
  const { t } = useTranslation()
  
  const service = {
    heroSlides: [
      {
        image: hero1, // ✅ Use imported variable
        title: t('construction.heroSlides.0.title'),
        subtitle: t('construction.heroSlides.0.subtitle'),
        description: t('construction.heroSlides.0.description')
      },
      {
        image: hero2,
        title: t('construction.heroSlides.1.title'),
        subtitle: t('construction.heroSlides.1.subtitle'),
        description: t('construction.heroSlides.1.description')
      },
      {
        image: hero3,
        title: t('construction.heroSlides.2.title'),
        subtitle: t('construction.heroSlides.2.subtitle'),
        description: t('construction.heroSlides.2.description')
      }
    ],
    introText: t('construction.introText'),
    stats: [
      { value: "95%", label: t('construction.stats.architectureExcellence') },
      { value: "75%", label: t('construction.stats.renovationEfficiency') },
      { value: "85%", label: t('construction.stats.spaceOptimization') },
      { value: "100%", label: t('construction.stats.safetyCompliance') }
    ],
    capabilities: t('construction.capabilities', { returnObjects: true }),
    services: [
      {
        icon: Building2,
        title: t('construction.services.turnkeyConstruction.title'),
        description: t('construction.services.turnkeyConstruction.description'),
        image: turnkeyImg // ✅ Use imported variable
      },
      {
        icon: Truck,
        title: t('construction.services.equipmentLeasing.title'),
        description: t('construction.services.equipmentLeasing.description'),
        image: equipmentImg
      },
      {
        icon: Users,
        title: t('construction.services.generalContracting.title'),
        description: t('construction.services.generalContracting.description'),
        image: contractingImg
      },
      {
        icon: Ruler,
        title: t('construction.services.buildingDesign.title'),
        description: t('construction.services.buildingDesign.description'),
        image: designImg
      },
      {
        icon: HardHat,
        title: t('construction.services.siteDevelopment.title'),
        description: t('construction.services.siteDevelopment.description'),
        image: siteImg
      },
      {
        icon: CheckCircle,
        title: t('construction.services.renovationServices.title'),
        description: t('construction.services.renovationServices.description'),
        image: renovationImg
      }
    ],
    workflow: [
      {
        step: "01",
        title: t('construction.workflow.0.title'),
        description: t('construction.workflow.0.description')
      },
      {
        step: "02",
        title: t('construction.workflow.1.title'),
        description: t('construction.workflow.1.description')
      },
      {
        step: "03",
        title: t('construction.workflow.2.title'),
        description: t('construction.workflow.2.description')
      },
      {
        step: "04",
        title: t('construction.workflow.3.title'),
        description: t('construction.workflow.3.description')
      }
    ]
  }

  return (
    <>
      <SEO 
        title="Construction Services | Turnkey Solutions & General Contracting"
        description="AL-KONDA Group offers comprehensive construction services including turnkey construction, equipment leasing, general contracting, building design, and renovation services in Iraq."
        keywords="construction services Iraq, turnkey construction, general contracting, building design, site development, renovation services"
        url="/services/construction"
      />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <ServicePageLayout
        title={service.heroSlides[0].title}
        subtitle={service.heroSlides[0].subtitle}
        description={service.heroSlides[0].description}
        backgroundImages={service.heroSlides.map(slide => slide.image)}
        heroSlides={service.heroSlides}
        introText={service.introText}
        capabilities={service.capabilities}
        services={service.services}
        stats={service.stats}
        workflow={service.workflow}
      />
      </Suspense>
    </>
  )
}

export default Construction